export enum TypeSearchOperator {
  NessunFiltroOperatore = '0',
  NessunOperatore = '1',
  FiltroPerOperatore = '2',
}
